import { Component, effect, inject } from '@angular/core';
import { PageHeaderComponent } from '@/components/shared/page-header/page-header.component';
import { DataTableBuilderComponent } from '@/components/data-table-builder/data-table-builder.component';
import { DataTableRowActions, DataTableServerQuery, DynamicDataTable } from '@/components/data-table-builder/data-table.types';
import { AoService } from './ao.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { getAoDataTableStructure } from './utils/ao.data-table.object';
import { Ao } from '@/types';
import { createServerQuery } from '@/components/data-table-builder/server-query';
import { AoRepository } from '@/store/ao-state/ao-state.repository';
import { Router } from '@angular/router';
import { AuthorizationService } from '@/services/authorization.service';
import { UserRole } from '@/types/user.types';

@Component({
  selector: 'sm-ao',
  imports: [PageHeaderComponent, DataTableBuilderComponent],
  templateUrl: './ao.component.html',
  styleUrl: './ao.component.scss',
})
export class CallForTenderComponent {
  aoService = inject(AoService);
  aoRepository = inject(AoRepository);
  messageService = inject(MessageService);
  translate = inject(TranslateService);
  router = inject(Router);
  authService = inject(AuthorizationService);

  breadcrumb = [
    {
      label: 'ao.plural',
      routerLink: ['call-for-tender'],
    },
  ];

  data: Ao[] = [];
  totalRecords = 0;
  serverQuery: DataTableServerQuery = createServerQuery({ initialPageSize: 10, initialSortBy: 'updatedAt', initialSortOrder: 'desc' });
  rowActions: DataTableRowActions = {
    inspectAction: (row: Ao) => {
      this.router.navigate([`inspect-call-for-tender/${row.id}`]);
    },
    editAction: (row: Ao) => {
      this.router.navigate([`edit-call-for-tender/${row.id}`]);
    },
  };
  dataTableObject?: DynamicDataTable = getAoDataTableStructure({
    createAction: this.authService.hasRoles([UserRole.ADMIN_CENTRAL, UserRole.SUPER_ADMIN, UserRole.REDACTEUR_AC]) ? () => this.router.navigate(['new-tender']) : undefined,
    store: this.aoRepository,
    serverQuery: this.serverQuery,
    rowActions: this.rowActions,
  });
  loading = true;

  constructor() {
    let firstRun = true;

    effect(() => {
      const page = this.serverQuery.page();
      const size = this.serverQuery.pageSize();
      const sortBy = this.serverQuery.sortBy();
      const sortOrder = this.serverQuery.sortOrder();
      const search = this.serverQuery.search();
      const sort = sortBy ? `${sortBy},${sortOrder}` : '';

      if (firstRun) {
        firstRun = false;
        return;
      }

      this.loadData(page, size, search, sort);
    });
  }

  loadData(page = 0, size = 10, search = '', sort = '') {
    this.loading = true;
    this.aoService.getAos({ page, size, search, sort }).subscribe({
      next: data => {
        this.data = data.content;
        this.totalRecords = data.totalElements;
        this.loading = false;
      },
      error: error => {
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: error.message || this.translate.instant('ao.message.error.loading'),
        });
      },
    });
  }
}
